import chevDown from 'assets/chevron-down.svg'
import { FormSelects } from 'components/FormInputSelect'
import CustomInput from 'pages/auth/CustomInput'
import React, { useState } from 'react'

const DetailLagu = ({ genre, era, onChangeSelect, dataDetailLagu, page }) => {

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: '8px',
      border: '1px solid var(--border-strong)',
      color: 'var(--text-strong)'
    }),
    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      padding: "13px 24px",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      margin: "0px",
      paddingLeft: "16px",
      color: 'var(--text-strong)',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '20px'
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    singleValue: (state) => ({
      marginLeft: '16px',
      gridArea: '1/1/2/3',
      maxWidth: '100%',
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      color: "hsl(0, 0%, 20%)",
      marginLeft: "16px",
      marginRight: "2px",
      boxSizing: "border-box"
    })
  };


  return (
    <div className='detail-lagu-container' {...(page && { style: { width: '100%' } })}>
      <h3>3. Detail Lagu</h3>
      <FormSelects
        placeholder="Genre"
        styles={customStyles}
        name="genre"
        isDisabled={page === 'detail' ? true : false}
        options={genre}
        value={dataDetailLagu.genre}
        onChange={onChangeSelect}
      />
      <FormSelects
        placeholder="Era Lagu"
        name="era_lagu"
        isDisabled={page === 'detail' ? true : false}
        styles={customStyles}
        options={era}
        value={dataDetailLagu.era}
        onChange={onChangeSelect}
      />
    </div>
  )
}

export default DetailLagu